import React, { memo } from "react";

interface FooterLinkProps {
  text: string;
  href: string;
  isLast?: boolean;
}

const FooterLink: React.FC<FooterLinkProps> = memo(
  ({ text, href, isLast = false }) => (
    <>
      <a
        className="hover:underline text-gray-200 h-6 md:h-4 leading-none no-underline"
        href={href}
      >
        {text}
      </a>
      {!isLast && (
        <span
          className="h-2.5 hidden border-0 md:block md:border-solid md:border-r md:border-green-200"
          style={{ marginTop: "1.5px" }}
        />
      )}
    </>
  ),
);

const Subfooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="text-gray-200 text-sm font-normal">
      <div className="w-full !flex flex-col-reverse text-center xl:flex-row md:text-left xl:justify-between">
        <div className="py-8 md:py-6 xl:pt-1">
          &copy; {currentYear} The WEBstaurant Store, LLC - All Rights Reserved.
        </div>
        <div className="!flex flex-col md:flex-row pt-1 xl:pt-[6px] gap-2">
          <FooterLink text="Terms of Sale" href="/policies.html" />
          <FooterLink
            text="Privacy Policy"
            href="/policies.html#Privacy_Policy"
          />
          <FooterLink text="Terms of Use" href="/policies.html#Terms_of_Use" />
          <FooterLink
            text="Accessibility Policy"
            href="/policies.html#Website_Accessibility_Policy"
          />
          <FooterLink
            text="Do Not Sell or Share My Personal Information"
            href="/policies.html#US_Privacy_Rights"
            isLast
          />
        </div>
      </div>
    </div>
  );
};

export default Subfooter;
